import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type DeleteMaterialResponse = ClientInferResponseBody<
  typeof contract.materials.deleteMaterial,
  200
>;

export const deleteMaterialApi = async ({
  id,
}: {
  id: string;
}): Promise<DeleteMaterialResponse> => {
  const response = await api.materials.deleteMaterial.mutation({
    params: { id },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to delete material", response.status, response.body);
};
